import { Skeleton } from 'antd';
import type { FC } from 'react';

const TILE_COUNT = 6;

const DriverTileSkeleton: FC = () => {
  return (
    <div
      style={{
        padding: '12px 16px',
        borderBottom: '1px solid #f0f0f0',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'flex-start' }}>
        <Skeleton.Avatar active size={48} style={{ flexShrink: 0, marginRight: 12 }} />
        <div style={{ flex: 1, minWidth: 0 }}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: 4,
            }}
          >
            <Skeleton.Input active size="small" style={{ width: 120, height: 18 }} />
            <Skeleton.Input active size="small" style={{ width: 50, height: 14 }} />
          </div>
          <Skeleton.Input active size="small" style={{ width: 160, height: 14, marginBottom: 8 }} />
          <div style={{ display: 'flex', gap: 8 }}>
            <Skeleton.Button active size="small" style={{ width: 60, height: 22 }} />
          </div>
        </div>
      </div>
    </div>
  );
};

export const DriverTileListSkeleton: FC = () => {
  return (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <div style={{ padding: '8px 16px', borderBottom: '1px solid #f0f0f0' }}>
        <Skeleton.Input active size="small" style={{ width: 260, height: 22 }} />
      </div>
      <div>
        {Array.from({ length: TILE_COUNT }, (_, i) => (
          // biome-ignore lint/suspicious/noArrayIndexKey: static skeleton placeholder
          <DriverTileSkeleton key={i} />
        ))}
      </div>
    </div>
  );
};
